module.exports = __webpack_public_path__ + "img/238.compressor_rails.134d6bb9.svg";